export const GenericMenuCategories = {
    UNKNOWN: {
        value: 'Uncategorized',
        label: 'Uncategorized'
    }
};
